var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#0A1628"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 41.5) scale(0.952)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.086 8.99809L7.97229 12.8585L0 15.9029L5.11216 8.99809L0 2.09326L7.97229 5.13763L18.086 8.99809Z",
    fill: "#2D9BAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8613 0H33.9661C39.0201 0 40.277 2.19357 40.277 4.15273V4.41318C40.277 6.60965 38.3538 7.93794 37.027 8.10579C39.0201 8.38939 41.1557 9.85949 41.1557 12.6666V12.927C41.1557 15.3087 39.7068 18 34.036 18H20.8584V0H20.8613ZM26.4157 3.70418V6.79775H32.5899C34.0621 6.79775 34.5131 6.08875 34.5131 5.26109C34.5131 4.41318 34.0389 3.70129 32.5899 3.70129H26.4157V3.70418ZM26.4157 10.4614V13.8502H32.9681C34.6993 13.8502 35.1765 12.9791 35.1765 12.0791V12.0646C35.1765 11.1936 34.7022 10.4614 32.9681 10.4614H26.4157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5093 0L56.9549 10.0534V0H62.5093V18H55.9686L48.6218 8.07974V18H43.0732V0H49.5122H49.5093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2412 10.5077L62.4609 0H69.3305L73.2323 5.26977L77.134 0H84.0036L76.2233 10.5077V18H70.2412V10.5077Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 18,
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnyLogo);
export default __webpack_public_path__ + "static/media/bny_logo.9777864da43031ca620bbb703519b4c0.svg";
export { ForwardRef as ReactComponent };